import lodash from 'lodash'
import config from './default'

let envConfig = {}

try {
  envConfig = process.env.NODE_ENV == 'development' ?
    require('./default').default :
    require('./prod').default
} catch (o_o) {
  console.warn('used default config now')
}

lodash.merge(config, envConfig)
export default config